/**
 * authStore global: token, isLoggedIn, selectedRole.
 * Source of truth para sesión; selectedRole se persiste en sessionStorage.
 */

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { RoleDto } from "common/models";

export type AuthState = {
    token: string | null;
    isLoggedIn: boolean;
    selectedRole: RoleDto | undefined;
    setToken: (token: string | null) => void;
    setLoggedIn: (loggedIn: boolean) => void;
    setSelectedRole: (role: RoleDto | undefined) => void;
    logout: () => void;
};

const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            token: null,
            isLoggedIn: false,
            selectedRole: undefined,
            setToken: (token) => set({ token }),
            setLoggedIn: (isLoggedIn) => set({ isLoggedIn }),
            setSelectedRole: (selectedRole) => set({ selectedRole }),
            logout: () =>
                set({
                    token: null,
                    isLoggedIn: false,
                    selectedRole: undefined,
                }),
        }),
        {
            name: "pideky-escala-app-auth",
            partialize: (state) => ({ selectedRole: state.selectedRole }),
            storage: createJSONStorage<{ selectedRole: RoleDto | undefined }>(() => sessionStorage),
        }
    )
);

export default useAuthStore;
